/*
App Download Bar Component

HTML Usage:
<app-download-bar data-options='{}'>
  App download bar content
</app-download-bar>
*/

if (!customElements.get('app-download-bar')) {
  class AppDownloadBar extends HTMLElement {
    constructor() {
      super();

      // Options
      this.options = {
        appName: 'Agradi',
        appUrl: 'http://reskyt.com/app/agradi',
        appIcon: 'https://cdn.reskyt.com/7629/agradi-icono-app-455033-250604121156.png',
        tipText: 'Tip: download onze app',
        titleText: 'Blijf op de hoogte van acties en ontvang app-only aanbiedingen!',
        cookieName: 'reskyt-install-app',
        cookieExpireDays: 7,
        appInstallBarCookie: 'is_app_install_bar',
        appInstallBarExpireDays: 365,
      };
    }

    connectedCallback() {
      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions,
        };
      }

      // Initialize the component
      this.init();
    }

    /*
      Initialize the app download bar
    */
    init() {
      // Check if we should show the bar
      if (this.shouldShowBar()) {
        this.show();
        this.setupEventListeners();
        this.detectPlatform();
      }
    }

    /*
      Check if the app download bar should be shown
    */
    shouldShowBar() {
      const isMobile = this.isMobileDevice();
      const hasAppInstallBarCookie = this.getCookie(this.options.appInstallBarCookie);
      const hasReskytInstallAppCookie = this.getCookie(this.options.cookieName);

      return isMobile && !hasAppInstallBarCookie && !hasReskytInstallAppCookie;
    }

    /*
      Check if device is mobile
    */
    isMobileDevice() {
      return /Android|iPhone|iPad|iPod|IEMobile/i.test(navigator.userAgent);
    }

    /*
      Detect platform and update text
    */
    detectPlatform() {
      const platformElement = this.querySelector('#platform-app');
      if (!platformElement) return;

      if (/Android/i.test(navigator.userAgent)) {
        platformElement.innerHTML = 'Google Play';
      } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        platformElement.innerHTML = 'App Store';
      } else if (/IEMobile/i.test(navigator.userAgent)) {
        platformElement.innerHTML = 'Windows Phone';
      }
    }

    /*
      Show the app download bar
    */
    show() {
      this.style.display = 'block';
    }

    /*
      Hide the app download bar
    */
    hide() {
      this.style.display = 'none';
    }

    /*
      Close the app download bar
    */
    close() {
      this.setCookie(this.options.cookieName, 1, this.options.cookieExpireDays);
      this.hide();
    }

    /*
      Setup event listeners
    */
    setupEventListeners() {
      // Close button event
      const closeButton = this.querySelector('.close-install-app');
      if (closeButton) {
        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      }

      // Check for customapp parameter in URL
      const url = window.location.href;
      if (url.indexOf('customapp=') !== -1) {
        this.setCookie(this.options.appInstallBarCookie, 1, this.options.appInstallBarExpireDays);
      }
    }

    /*
      Set cookie
      @param cname {string}: cookie name
      @param cvalue {string}: cookie value
      @param exdays {number}: expiration days
    */
    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    /*
      Get cookie
      @param cname {string}: cookie name
      @return {string}: cookie value
    */
    getCookie(cname) {
      const name = cname + '=';
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');

      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }
  }

  window.AppDownloadBar = AppDownloadBar;
  customElements.define('app-download-bar', AppDownloadBar);
}
